import 'angular';
import routesModule from '../../utilities/routes_module';
angular
  .module('models.ConsultantMinimalModel', [])
  .service('ConsultantMinimalModel', function() {
    return function(data) {
      this.id = data.id;
      this.headline = data.headline;

      this.link = routesModule.person_path({ id: data.slug_and_id });

      if(data.full_name || data.first_name && data.last_name) {
        this.contact = routesModule.new_message_path({
          'recipient_ids': [this.id],
          'recipient_names': [data.full_name || data.first_name + ' ' + data.last_name],
          'return_to': location.href
        });
      }
    };
  }
  );
